import React from 'react';

/**
 * Reusable inner section-cover page for the Managerial Cross Report.
 * Same purple-gradient background as the main cover — acts as a chapter divider.
 *
 * Props:
 *   pageNumber  {string|number}       – page label shown faded top-left (e.g. "02"). Required.
 *   title       {string}              – main headline, displayed uppercase. Required.
 *   subtitle    {string}              – teal italic line below the title. Required.
 *   insight     {string|null}         – optional italic note below subtitle.
 *   statValue   {string|number|null}  – optional large number on the right (e.g. 48).
 *   statLabel   {string|null}         – optional label below the stat number (e.g. "Supervisores\nevaluados").
 */
const ManCrossPageSectionCover = ({
    pageNumber,
    title,
    subtitle,
    insight    = null,
    statValue  = null,
    statLabel  = null,
}) => (
    <div className="mgcr-scover">

        {/* ── Faded page number, top-left ── */}
        {pageNumber != null && (
            <div className="mgcr-scover-page-num" aria-hidden="true">
                {String(pageNumber).padStart(2, '0')}
            </div>
        )}

        {/* ── Decorative watermark numbers, bottom strip ── */}
        {/* <div className="mgcr-scover-watermark" aria-hidden="true">
            {['3', '5', '8', '1', '6', '2', '4', '7', '9', '0'].map((d, i) => (
                <span key={i}>{d}</span>
            ))}
        </div> */}

        {/* ── Main content block, vertically centred ── */}
        <div className="mgcr-scover-body">

            {/* Left: title + subtitle + optional insight */}
            <div className="mgcr-scover-text">
                <h2 className="mgcr-scover-title">{title}</h2>
                <p  className="mgcr-scover-subtitle">{subtitle}</p>
                {insight && (
                    <p className="mgcr-scover-insight">
                        <strong>Insight:</strong>{' '}{insight}
                    </p>
                )}
            </div>

            {/* Right: optional stat */}
            {statValue != null && (
                <div className="mgcr-scover-stat">
                    <span className="mgcr-scover-stat-value">{statValue}</span>
                    {statLabel && (
                        <span className="mgcr-scover-stat-label">{statLabel}</span>
                    )}
                </div>
            )}

        </div>

    </div>
);

export default ManCrossPageSectionCover;
